import { AxiosError, AxiosInstance } from 'axios';
import get from 'lodash/get';
import { showPopup } from './utils';

const withInterceptors = (instance: AxiosInstance): AxiosInstance => {
    // In order to handle response errors we need use a more complicated strategy
    //
    // instance.interceptors.response.use(
    //     (response: AxiosResponse): AxiosResponse => response,
    //     responseErrorInterceptor,
    // );

    return instance;
};

/**
 * Show modal window with an error message.
 *
 * @param error
 */
const responseErrorInterceptor = (error: AxiosError): any => {
    // You can disable error handling by passing { errorHandle: false } to axios request config
    if (error.config.hasOwnProperty('errorHandle') && !(error.config as any).errorHandle) {
        return Promise.reject(error);
    }

    const errors = get(error, 'response.data.errors', []);

    if (Array.isArray(errors) && errors.length) {
        const errorMessage = `<div style="min-height:250px; padding: 15px; font-size: 1.3em; line-height: 1.3; display: flex; align-items: center; background-color: red; color: white">${errors[0].message}</div>`;
        showPopup(errorMessage);
    }

    return Promise.resolve(error.response);
};

export {withInterceptors, responseErrorInterceptor};



// WEBPACK FOOTER //
// ./src/helpers/interceptors.ts